export default __webpack_public_path__ + "static/media/Mahligai_Aerial View@2x.201b482a.png";